<div
  class="component-container text-cool-grey h-full flex flex-col justify-center items-center space-y-[2.4rem]">
  <div
    class="verify-account-form-container w-full flex flex-col justify-center items-center p-[4rem]">
    <app-step-progress-indicator
      *ngIf="!tfa"
      [currentStep]="3"
      [totalSteps]="5"
    ></app-step-progress-indicator>
    <div
      class="heading font-poppins font-bold mb-[2.4rem] flex justify-center text-center ">
      Verify your account
    </div>
    <div
      class="message font-work-sans font-normal mb-[2.4rem] text-center"
    >
      Please enter your verification code sent to your phone
      number {{formatedPhoneNumber}}.
      <span
        *ngIf="!tfa"
        class="link underline text-digital-blue-light cursor-pointer"
        (click)="changePhoneNumber()"
      >
         Change Phone Number
      </span>
    </div>
    <form>
      <div class="label mb-[0.8rem] flex justify-center">
        Enter One Time Verification Code
        <span
          class="required-mark font-work-sans"
        >*</span>
      </div>
      <app-otp-input
        class="otp-input w-full"
        [parentFormGroup]="form"
        controlName="otp"
        [error]="errorMessages['otp']"
        (keyup.enter)="verifyOtp()"
      ></app-otp-input>
      <div class="action-section w-full">
        <app-primary-button
          type="small"
          [isLoading]="verifyOtpLoading"
          (click)="verifyOtp()"
        >
          VERIFY
        </app-primary-button>
      </div>
    </form>
    <div class="subMessage w-full font-work-sans font-normal mb-[1rem] text-center">
      <hr class="mb-[2.4rem] mt-[2.4rem]">
      I have not received the verification code?
      <span
        class="link underline"
        (click)="resend()"
        [ngClass]="!generateOtpSuccess ? 'enableText' : 'disableText'"
      >
        Resend
      </span>
    </div>
    <div
      *ngIf="generateOtpSuccess"
      class="timer-container flex flex-row justify-center items-end"
    >
      <app-timer
        [timerDuration]="timerValue"
        (handleTimerComplete)="handleCounterComplete()"
      ></app-timer>
    </div>
  </div>
</div>
